var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { "has-line": true, title: "Historial de Hallazgos UMESR" }
      }),
      _c("div", { staticClass: "bg-secondary-3 rounded pt-2 pb-3 px-4" }, [
        _c("div", { staticClass: "row student bg-white p-3 rounded mb-2" }, [
          _c("div", { staticClass: "col-6 col-md-3 mb-3" }, [
            _vm._m(0),
            _c("span", { staticClass: "student__info" }, [
              _vm._v(" " + _vm._s(_vm.student.studentSieId) + " ")
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
            _vm._m(1),
            _c("span", { staticClass: "student__info" }, [
              _vm._v(" " + _vm._s(_vm.student.studentFullName) + " ")
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
            _vm._m(2),
            _c("span", { staticClass: "student__info" }, [
              _vm._v(" " + _vm._s(_vm.student.impedimentName) + " ")
            ])
          ])
        ]),
        _c("div", { staticClass: "row student p-3 rounded mb-2" }, [
          _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
            _c("div", { staticClass: "student__label" }, [
              _vm._v(" Tipo de Servicio: ")
            ]),
            _c("span", { staticClass: "student__info" }, [
              _vm._v(" " + _vm._s(_vm.student.disciplineTypeName) + " ")
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
            _c("div", { staticClass: "student__label" }, [
              _vm._v(" Proveedor: ")
            ]),
            _c("span", { staticClass: "student__info" }, [
              _vm._v(" " + _vm._s(_vm.student.companyName) + " ")
            ])
          ]),
          _c("div", { staticClass: "col-12 col-md-3 mb-3" }, [
            _c("div", { staticClass: "student__label" }, [
              _vm._v(" Referido: ")
            ]),
            _c("span", { staticClass: "student__info" }, [
              _vm._v(" " + _vm._s(_vm.student.referralNumber) + " ")
            ])
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "student__label" }, [
      _c("em", {
        staticClass: "student__label_icon fas fa-address-book text-orange"
      }),
      _vm._v(" SIE: ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "student__label" }, [
      _c("em", {
        staticClass: "student__label_icon fas fa-address-book text-orange"
      }),
      _vm._v(" Nombre del Estudiante: ")
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "student__label" }, [
      _c("em", {
        staticClass: "student__label_icon fas fa-ballot-check text-orange"
      }),
      _vm._v(" Impedimento: ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }